import React, { useState, useEffect } from 'react';

interface LoadValues {
  x: number;
  y: number;
  z: number;
}

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (values: LoadValues) => void;
  initial?: LoadValues;
  title?: string;
}

export const LoadInputModal: React.FC<Props> = ({ isOpen, onClose, onSave, initial, title }) => {
  const [values, setValues] = useState<LoadValues>(initial || { x: 0, y: 0, z: 0 });

  useEffect(() => {
    setValues(initial || { x: 0, y: 0, z: 0 });
  }, [initial, isOpen]);

  const handleSubmit = () => {
    onSave(values);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black opacity-30" onClick={onClose} />
  <div className="bg-white rounded shadow-lg p-4 w-96 z-50 text-black">
  <h3 className="text-lg font-medium mb-2">{title || 'Node Load'} (enter X/Y/Z, negatives allowed)</h3>
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th className="text-left">Plane</th>
              <th className="text-left">Value (kN)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="py-2">X Plane</td>
              <td>
                <input
                  type="number"
                  step="any"
                  placeholder="e.g., -10"
                  value={values.x}
                  onChange={(e) => setValues({ ...values, x: Number(e.target.value) })}
                  className="w-full border px-2 py-1 rounded text-black"
                  onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
                />
              </td>
            </tr>
            <tr>
              <td className="py-2">Y Plane</td>
              <td>
                <input
                  type="number"
                  step="any"
                  placeholder="e.g., 5.5"
                  value={values.y}
                  onChange={(e) => setValues({ ...values, y: Number(e.target.value) })}
                  className="w-full border px-2 py-1 rounded text-black"
                  onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
                />
              </td>
            </tr>
            <tr>
              <td className="py-2">Z Plane</td>
              <td>
                <input
                  type="number"
                  step="any"
                  placeholder="e.g., 0"
                  value={values.z}
                  onChange={(e) => setValues({ ...values, z: Number(e.target.value) })}
                  className="w-full border px-2 py-1 rounded text-black"
                  onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
                />
              </td>
            </tr>
          </tbody>
        </table>

        <div className="flex justify-end mt-4 space-x-2">
          <button onClick={onClose} className="px-3 py-1 rounded bg-gray-200">Cancel</button>
          <button
            onClick={handleSubmit}
            className="px-3 py-1 rounded bg-blue-600 text-white"
          >OK</button>
        </div>
      </div>
    </div>
  );
};

export default LoadInputModal;
